import { Link } from 'react-router-dom';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import SlideCarousel from 'components/SlideCarousel';
import { SlideCarouselPagination } from 'components/SlideCarousel/styles';
import { Card } from 'components/TripCard/styles';

export const SectionTitle = styled.h3`
  margin-bottom: 32px;
  font-weight: 600;
  line-height: 1.13;
  letter-spacing: -0.5px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const HeaderWithLink = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AllTripsLink = styled(Link)`
  margin-left: 24px;
  margin-bottom: 32px;
  flex-shrink: 0;
  font-size: 12px;
  align-self: flex-end;
  text-decoration: none;

  &::after {
    content: url('/images/chevron-right-active.svg');
    margin-left: 8px;
  }
`;

export const TripCarousel = styled(SlideCarousel)`
  margin: 0 -16px;

  & ${Card} {
    width: calc(100% - 32px);
    margin: 8px 16px;
  }

  & ${SlideCarouselPagination} {
    position: relative;
    top: -40px;
  }
`;

// We need this wrapper, since our (and most) carousels have hidden overflow for their viewports.
// So we provide 40px for the box-shadow
export const TripCardWrapper = styled.div`
  width: 100%;
  padding-bottom: 40px;
`;
